export default "__VITE_ASSET__30d02764__"